import actionConstants from '../constants/';
import { matchesApiCancelKey } from '../apiCancelKeys';

const fetchPaymentModesState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorCode: 0,
  data: [],
  errorMessage: '',
};

const initialState = {
  fetchPaymentModes: { ...fetchPaymentModesState },
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function fetchPaymentModesDataReducer(state = initialState, action) {
  switch (action.type) {
    case actionConstants.CANCEL_API_REQUEST:
      return matchesApiCancelKey(
        action.payload,
        actionConstants.FETCH_PAYMENT_MODES
      )
        ? {
            ...state,
            fetchPaymentModes: {
              ...state.fetchPaymentModes,
              isLoading: false,
            },
          }
        : state;

    case actionConstants.FETCH_PAYMENT_MODES_REQUEST:
      return {
        ...state,
        fetchPaymentModes: {
          ...state.fetchPaymentModes,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorCode: 0,
        },
      };
    case actionConstants.FETCH_PAYMENT_MODES_SUCCESS:
      return {
        ...state,
        fetchPaymentModes: {
          ...state.fetchPaymentModes,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };
    case actionConstants.FETCH_PAYMENT_MODES_FAILURE:
      return {
        ...state,
        fetchPaymentModes: {
          ...state.fetchPaymentModes,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorCode: action.payload.errorCode,
          errorMessage: action.payload.errorMessage,
        },
      };
    case actionConstants.FETCH_PAYMENT_MODES_CLEAR:
      return {
        ...state,
        fetchPaymentModes: {
          ...initialState.fetchPaymentModes,
          data: [],
        },
      };

    default:
      return state;
  }
}
